import React from 'react';
import { signOut } from "firebase/auth";
import { auth } from '../../config/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import {
  getFirestore,
  doc,
  updateDoc,
  arrayUnion
} from "firebase/firestore";
import './Logout.css'; // ←追加

const db = getFirestore();

const Logout = ({ setIsAuth }) => {
  const navigate = useNavigate();

  const logLogoutActivity = async () => {
    const user = auth.currentUser;
    if (!user) return;

    const userRef = doc(db, "users", user.uid);
    const currentProjectID = localStorage.getItem("currentProjectID");

    try {
      await updateDoc(userRef, {
        activityLog: arrayUnion({
          action: "logout",
          at: new Date().toISOString(),
        }),
        ...(currentProjectID && { lastProjectAccessed: currentProjectID })
      });
    } catch (err) {
      console.error("ログアウトログの記録に失敗:", err);
    }
  };

  const logout = async () => {
    try {
      await logLogoutActivity();
      await signOut(auth);
      localStorage.removeItem("isAuth");
      setIsAuth(false);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      alert("ログアウトに失敗しました。もう一度お試しください。");
    }
  };

  return (
    <div className="logout-container">
      <div className="logout-box">
        <p className="logout-title">ログアウトしますか？</p>
        <button className="logout-btn" onClick={logout}>
          ログアウト
        </button>
      </div>
    </div>
  );
};

export default Logout;
